export const style = {
  h2: {
    fontSize: `31px`,
    fontWeight: 300,
    lineHeight: `42px`,
    margin: `0 0 32px 0`,
    color: `black`
  },
  h3: {
    fontSize: `25px`,
    fontWeight: 300,
    lineHeight: `24px`,
    margin: `0 0 32px 0`,
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Advertisers/style/headers.js